import { render, staticRenderFns } from "./DinvoiceView.vue?vue&type=template&id=23e6c1ae&scoped=true"
import script from "./DinvoiceView.vue?vue&type=script&lang=js"
export * from "./DinvoiceView.vue?vue&type=script&lang=js"
import style0 from "./DinvoiceView.vue?vue&type=style&index=0&id=23e6c1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6c1ae",
  null
  
)

export default component.exports